import { createSelector } from 'reselect';
import { RootState } from 'Store/Reducers/RootReducer';

const getAiChatStore = (state: RootState) => state.aiChatStore;

const getChats = createSelector(getAiChatStore, (state) => state.chats);
const getActiveChatUuid = createSelector(getAiChatStore, (state) => state.activeChatUuid);
const getMessages = createSelector(getAiChatStore, (state) => state.messages);
const getIsStreaming = createSelector(getAiChatStore, (state) => state.isStreaming);
const getStreamBuffer = createSelector(getAiChatStore, (state) => state.streamBuffer);
const getError = createSelector(getAiChatStore, (state) => state.error);
const getIsConnected = createSelector(getAiChatStore, (state) => state.isConnected);

export { getChats, getActiveChatUuid, getMessages, getIsStreaming, getStreamBuffer, getError, getIsConnected };
